module.exports = __webpack_public_path__ + "static/media/play_circle_blue.62ad9e2b.svg";